



















































import {
  computed,
  defineComponent,
  useContext,
  useStore,
} from '@nuxtjs/composition-api'
import { IHolidayTheme } from '@/contracts/Settings'

const loadComponent = (component: string) => {
  return () =>
    import(`@/views/${component.replace(/section/i, 'Section')}`).catch(() => {
      console.error(`Component ${component} not found`)
      return { template: `<div>Component ${component} not found</div>` }
    })
}

export default defineComponent({
  name: 'Mediator',
  props: {
    components: {
      type: Array,
      default: () => [],
    },
    hideContent: {
      type: Boolean,
      default: false,
    },
    hideDelimiters: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const context = useContext()
    const store = useStore()
    const isDebugTemplatesShown = computed(
      () => context.$config.IS_DEBUG_TEMPLATES_SHOWN ?? false
    )
    const holidayTheme = computed<IHolidayTheme>(
      () => store.getters['settings/holidayTheme']
    )

    const parsedComponents = computed(() => {
      const currentComponents = (props.components as any).filter(
        (item: any) => item.type !== 'skip'
      )

      if (!props.components) return []

      const finalComponent = currentComponents.reduce(
        (components: any, component: any) => {
          const { type = 'Dummy' } = component || {}

          const componentMapped = {
            ...component,
            type,
            compFunc: loadComponent(type),
          }

          return type === 'dummy' &&
            context.$config.IS_DEBUG_TEMPLATES_SHOWN === 'false'
            ? components
            : [...components, componentMapped]
        },
        []
      )

      return props.hideContent &&
        !!finalComponent.find((component) => component.name === 'sectionIframe')
        ? finalComponent.filter(
            (component) => component.name === 'sectionIframe'
          )
        : finalComponent
    })

    return {
      parsedComponents,
      isDebugTemplatesShown,
      holidayTheme,
    }
  },
})
